import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import CanDoList from './CanDoList';
import CanDosListService from '../../services/CanDosListService';

class CanDoListContainer extends Component {
  static propTypes = {
    courseId: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    CanDosListService.init(this.props.courseId);
  }

  render() {
    return (
      <CanDoList
        items={toJS(CanDosListService.items)}
        fetching={CanDosListService.fetch.fetching}
        onDelete={CanDosListService.handleRemove}
      />
    );
  }
}

export default observer(CanDoListContainer);
